import React from 'react';
import Box from "@cloudscape-design/components/box";
import ColumnLayout from "@cloudscape-design/components/column-layout";
import Container from "@cloudscape-design/components/container";
import Header from "@cloudscape-design/components/header";
import SpaceBetween from "@cloudscape-design/components/space-between";

const ModernizationOverview = () => {
  return (
    <Container
      header={
        <Header variant="h2">
          Modernization overview
          <span style={{ fontWeight: 'normal', marginLeft: '5px' }}>- new</span>
        </Header>
      }
    >
      <SpaceBetween size="l">
        <Box variant="p">Viewing data from N. Virginia (us-east-1) Region</Box>
        <ColumnLayout columns={4} variant="text-grid">
          <div>
            <Box variant="awsui-key-label">Total Jobs</Box>
            <Box variant="h1" color="text-label-blue">14</Box>
          </div>
          <div>
            <Box variant="awsui-key-label">Applications</Box>
            <Box variant="h1" color="text-label-blue">12</Box>
          </div>
          <div>
            <Box variant="awsui-key-label">Success Rate</Box>
            <Box variant="h1" color="text-label-blue">79%</Box>
          </div>
          <div>
            <Box variant="awsui-key-label">Av. Completion Time</Box>
            <Box variant="h1" color="text-label-blue">0h 32m</Box>
          </div>
        </ColumnLayout>
      </SpaceBetween>
    </Container>
  );
};

export default ModernizationOverview;
